import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import ListItemText from '@mui/material/ListItemText';
import CardMedia from '@mui/material/CardMedia';

// import P1 from 'assests/Photos/alumini/20-21/riya1.jpg'
// import P2 from 'assests/Photos/alumini/20-21/adithyashanker2.jpg'
// import P3 from 'assests/Photos/alumini/20-21/samrit3.jpg'
// import P4 from 'assests/Photos/alumini/20-21/nirmal4.jpg'
// import P5 from 'assests/Photos/alumini/20-21/navya5.jpg'
// import P6 from 'assests/Photos/alumini/20-21/ayushman6.jpg'
// import P7 from 'assests/Photos/alumini/20-21/chhavi7.jpg'
// import P8 from 'assests/Photos/alumini/20-21/Mahima8.jpg'
// import P9 from 'assests/Photos/alumini/20-21/swarit9.jpg'

import Container from 'components/Container';



const Reviews = () => {

  const [config, setConfig] = useState({ base_image_url: '' });
  useEffect(() => {
    fetch('/config.json')
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);

  const P1 = `${config.base_image_url}/home/home-static/static-images/all-static-images/alumini/20-21/riya1.webp`;
  const P2 = `${config.base_image_url}/home/home-static/static-images/all-static-images/alumini/20-21/adithyashanker2.webp`;
  const P3 = `${config.base_image_url}/home/home-static/static-images/all-static-images/alumini/20-21/samrit3.webp`;
  const P4 = `${config.base_image_url}/home/home-static/static-images/all-static-images/alumini/20-21/nirmal4.webp`;
  const P5 = `${config.base_image_url}/home/home-static/static-images/all-static-images/alumini/20-21/navya5.webp`;
  const P6 = `${config.base_image_url}/home/home-static/static-images/all-static-images/alumini/20-21/ayushman6.webp`;
  const P7 = `${config.base_image_url}/home/home-static/static-images/all-static-images/alumini/20-21/chhavi7.webp`;
  const P8 = `${config.base_image_url}/home/home-static/static-images/all-static-images/alumini/20-21/Mahima8.webp`;
  const P9 = `${config.base_image_url}/home/home-static/static-images/all-static-images/alumini/20-21/swarit9.webp`;
  const batchListPdf = `${config.base_image_url}/home/home-static/static-images/all-static-images/alumini/20-21/BatchList2021.pdf`;
  

  const mock = [
    {
      name: 'RIYA MAHESH',
      title: 'ELECTRICAL ENGINERIN IIT MADRAS',
      avatar: P1,
    },
    {
      name: 'ADITYA SHANKER',
      title: 'BA LLB(Honours)JINDAL GLOBAL SCHOOL SONIPAT',
      avatar: P2,
    },
    {
      name: 'SAMRIT SAMEEP KUNJA',
      title: 'NATIONAL DEFENCE ACADEMY PUNE',
      avatar: P3,
    },
    {
      name: 'NIRMAL GOVINDRAJ',
      title: 'COMPUTER SCIENCE ENGINEERING BITS GOA ',
      avatar: P4,
    },
    {
      name: 'NAVYA SRINIVASAN',
      title: 'B Tech + MSc BIITS PILANI',
      avatar: P5,
    },
    {
      name: 'AYUSHMAAN SRIVASTAVA ',
      title: 'ELECTRONICS AND ELECTRICAL ENGINERIN NITK SURATHKAL',
      avatar: P6,
    },
    {
      name: 'CHHAVI KHANNA',
      title: 'BACHELOR OF ARCHITECTUR VIRGINIA TECH, USA',
      avatar: P7,
    },
    {
      name: 'MAHIMA PRASANNA',
      title: 'BACHELOR OF DESIGN IIT GUWAHATI',
      avatar: P8,
    },
    {
      name: 'SWARIT SINGH CHAUHAN',
      title: 'BACHELOR OF ENGINEERING UNIVERSITY OF CANTERBURY, CHRISTCHURCH, NEWZEALAND',
      avatar: P9,
    },
  ];

  return (
    <Container>
      <Box>
        <Box marginBottom={4}>
          <Typography
            sx={{
              textTransform: 'uppercase',
            }}
            gutterBottom
            color={'text.secondary'}
            align={'center'}
            fontWeight={700}
          >
            ACHIEVING MILESTONES
          </Typography>
          <Typography fontWeight={700} variant={'h4'} align={'center'}>
          CLASS 12 ( 2020-21)
          </Typography>
          <Typography>
          NPS YPR  heartly congratulates the  students of Class 12 for their noteworthy accomplishments and placements. Leading the pillar of excellence are:
            </Typography>
        </Box>
        <Grid container spacing={2}>
          {mock.map((item, i) => (
            <Grid item xs={12} sm={6} md={3} key={i}>
              <Card
                sx={{
                  boxShadow: 0,
                  background: 'transparent',
                  backgroundImage: 'none',
                }}
              >
                <Box
                  component={CardMedia}
                  borderRadius={2}
                  width={1}
                  height={1}
                  minHeight={320}
                  image={item.avatar}
                />
                <Box
                  component={CardContent}
                  bgcolor={'transparent'}
                  marginTop={-5}
                >
                  <Box component={Card}>
                    <CardContent>
                      <ListItemText
                        primary={item.name}
                        secondary={item.title}
                      />
                    </CardContent>
                  </Box>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 6 }}>
          <a href={batchListPdf} target="_blank" rel="noreferrer" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', minWidth: 125, minHeight: 28, padding: '0 16px', backgroundColor: '#5b9bd5', border: '1px solid #41719c', color: '#fff', fontSize: 12, fontWeight: 700, textDecoration: 'none', textTransform: 'uppercase' }}>
            BATCH LIST 2021
          </a>
        </Box>
      </Box>
    </Container>
  );
};

export default Reviews;
